import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMic = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 21,
	viewBox: "0 0 16 21",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 0.625C6.27411 0.625 4.875 2.02411 4.875 3.75V10C4.875 11.7259 6.27411 13.125 8 13.125C9.72589 13.125 11.125 11.7259 11.125 10V3.75C11.125 2.02411 9.72589 0.625 8 0.625ZM7 20.0002C7 20.5525 7.44771 21.0002 8 21.0002C8.55228 21.0002 9 20.5525 9 20.0002L9 16.994C10.665 16.7745 12.2222 16.0111 13.4221 14.8079C14.9605 13.2654 15.25 11.2226 15.25 9.37513C15.25 8.82285 14.8023 8.37513 14.25 8.37513C13.6977 8.37513 13.25 8.82285 13.25 9.37513C13.25 11.0733 12.968 12.431 12.006 13.3956C10.9431 14.4614 9.50203 15.0596 8 15.0596C6.49797 15.0596 5.05692 14.4614 3.994 13.3956C3.03196 12.431 2.75 11.0733 2.75 9.37513C2.75 8.82285 2.30229 8.37513 1.75 8.37513C1.19771 8.37513 0.75 8.82285 0.75 9.37513C0.75 11.2226 1.03947 13.2654 2.5779 14.8079C3.77783 16.0111 5.335 16.7745 7 16.994L7 20.0002Z",
		fill: "current"
	})]
});
const ForwardRef = forwardRef(SvgMic);
export { ForwardRef as ReactComponent };
